module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-04-9ca7db939346a46719ced569c029e2b3.svg";